function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Cash",
  d: "M24.809,18.3H5.822A2.046,2.046,0,0,1,3.8,16.235v-1.8H2.024A2.046,2.046,0,0,1,0,12.37V2.062A2.046,2.046,0,0,1,2.024,0H21.011a2.046,2.046,0,0,1,2.025,2.062v1.8h1.772a2.046,2.046,0,0,1,2.025,2.062V16.235A2.046,2.046,0,0,1,24.809,18.3ZM5.315,14.431v1.8a.517.517,0,0,0,.506.515H24.809a.518.518,0,0,0,.508-.515V5.927a.518.518,0,0,0-.508-.515H23.037V12.37a2.046,2.046,0,0,1-2.025,2.062ZM2.024,1.546a.512.512,0,0,0-.506.516V12.37a.511.511,0,0,0,.506.515H21.011a.512.512,0,0,0,.508-.515V2.062a.513.513,0,0,0-.508-.516Zm9.494,8.247a2.577,2.577,0,1,1,2.531-2.576A2.557,2.557,0,0,1,11.518,9.792Zm6.8-1.8H17.056a.773.773,0,0,1,0-1.546h1.266a.773.773,0,0,1,0,1.546Zm-12.342,0H4.714a.773.773,0,0,1,0-1.546H5.98a.773.773,0,0,1,0,1.546Z",
  fill: "#ff7643"
});

var SvgIconCash = function SvgIconCash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.834,
    height: 18.297,
    viewBox: "0 0 26.834 18.297",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-cash.b1298f11.svg";
export { ForwardRef as ReactComponent };